import {
  EDIT_EVALUATION_INFO,
  EDIT_EVALUATION_QUESTION,
  INITIAL_EVALUATION,
  START_EVALUATION,
  SIGNUP_EVALUATION,
  COMPLETED_EVALUATION,
  PEER_SUBMITTED,
  CHANGE_EVALUATION_STATE,
  ADD_EVALUATION,
  ADD_EVALUATION_SUCCESS,
  ADD_EVALUATION_FAILED,
  EDIT_EVALUATION_AUTHOR,
  EDIT_EVALUATION_AUTHOR_SUCCESS,
  EDIT_PEER_RESPONSE,
  EDIT_PEER_RESPONSE_SUCCESS
} from "./constants";
import {
  default_list,
  twentyfivesections_list,
  profile_list,
  twelvesections_list
} from "./questionList";

const type = window.location.pathname.split("/")[1];
let questions;


switch (type) {
  case "profile":
    questions = profile_list;
    break;
  case "twentyfivesections":
    questions = twentyfivesections_list;
    break;

  case "twelvesections":
    questions = twelvesections_list;
    break;

  case "360":
    questions = default_list;

    break;
  default:
    questions = default_list;
}
const initialState = {
  fullName: "",
  email: "",
  age: "36-45",
  educationalLevel: "graduate",
  leadershipExp: "<5",
  numberOfReferences: "0-5",
  isTa: false,
  step: INITIAL_EVALUATION,
  scriptStep: 1,
  questions: questions
};

export default function evaluation(state = initialState, action) {
  switch (action.type) {
    case EDIT_EVALUATION_INFO:
      return {
        ...state,
        ...action.payload.data
      };

    case EDIT_EVALUATION_QUESTION:
      return {
        ...state,
        questions: {
          ...state.questions,
          [action.payload.id]: {
            value: action.payload.value
          }
        }
      };
    case ADD_EVALUATION:
    case EDIT_PEER_RESPONSE:
      return {
        ...state,
        submitting: true
      };
    case ADD_EVALUATION_SUCCESS:
      return {
        ...state,
        submitting: false,
        step: SIGNUP_EVALUATION,
        error: false,
        evaluationId: action.payload.id
      };
    case ADD_EVALUATION_FAILED:
      return {
        ...state,
        submitting: false,
        error: true
      };
    case START_EVALUATION:
      return {
        ...state
      };
    case EDIT_EVALUATION_AUTHOR:
      return {
        ...state,
        submitting: true
      };
    case EDIT_EVALUATION_AUTHOR_SUCCESS:
      return {
        ...state,
        step: COMPLETED_EVALUATION,
        submitting: false
      };
    case EDIT_PEER_RESPONSE_SUCCESS:
      return {
        ...state,
        step: PEER_SUBMITTED,
        submitting: false
      };
    case CHANGE_EVALUATION_STATE:
      return {
        ...state,
        step: action.payload.type
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/evaluation/reducer.js